<template>
    <Button :label="$t('generate_qr')" icon="pi pi-qrcode" class="p-button-help p-button-sm mr-2" @click="onShowModal"/>

    <Dialog v-model:visible="showModal" :modal="true" :dismissableMask="true" :draggable="false">
        <template #header>
            <h3>QR Code ({{shipmentNo}})</h3>
        </template>


        <BlockUI style="height:400px;width:300px" :blocked="blocked">
            <div id="printArea" style="text-align:center">
                <h5 style="margin: 0 !important;">{{ shipmentNo }}</h5>
                <h5 style="margin: 0 !important;">{{ orderNo }}</h5>
                <img :src="qrData" style="height:300px;width:300px;object-fit:fill" v-if="qrData"/>
            </div>
        </BlockUI>
        
        <template #footer>
            <Button label="Print" icon="pi pi-print" class="p-button-default" @click="onPrint" />
        </template>    
    </Dialog>

</template>
<script>
    export default{
        props:{
            data:{
                type:Object,
                default:null
            }
        },
        data(){
            return {
                qrData:null,
                showModal: false,
                blocked: false,
                dataUrl: "shipment/generate_qr",
                shipmentNo: "",
                orderNo: ""
            }
        },
        methods:{
            reset(){
                this.qrData = null;
            },
            onShowModal(){
                this.reset();

                this.shipmentNo = this.data.Shipment_No;
                this.orderNo = this.data.Order_No.replaceAll("\t", ", ").replaceAll("\n", ", ");

                var self = this;
                this.showModal = true;

                this.$axios.get(this.$API_URL + this.dataUrl + "/" + this.data.Id)
                    .then((response) => {
                        if (response.data.success) {
                            self.qrData = response.data.data;
                        }
                        else {
                            self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                            //self.showAssignModal = false;
                            self.showModal = false;
                        }
                        self.blocked = false;
                        
                    })
                    .catch(function (err) {
                        self.$parent.$toast.add({ severity: 'error', summary: "Error", detail: err.message, life: 120000});
                        self.blocked = false;
                        self.showModal = false;
                        //self.showAssignModal = false;
                    });
            },
            onPrint(){
                this.$htmlToPaper("printArea");
            }

        },
    }
</script>